import type { FC } from "react";

import Sar from "@/assets/images/Sar";

interface Props {
  /** ISO code of the currency, e.g. "SAR" or "JOD". */
  code?: string;
  /** Symbol text from the API, used when we have no drawing for the currency. */
  symbol?: string;
  classes?: string;
  /** Colour of the drawn symbol; only the SAR image uses it. */
  color?: string;
}

/**
 * Draws a currency's symbol next to an amount.
 *
 * The API sends a text symbol that every client can render. Where we ship the
 * symbol as a vector we draw that instead, because it looks better beside a
 * number than letters do — the Saudi Riyal sign is the only one we have, and
 * its Unicode character is too new for fonts to show, which is why it is an
 * image rather than text.
 */
const CurrencySymbol: FC<Props> = ({ code, symbol, classes, color }) => {
  if (code === "SAR") {
    return <Sar classes={classes ?? "w-3 h-3"} color={color} />;
  }

  return symbol ? <span>{symbol}</span> : null;
};

export default CurrencySymbol;
